module.exports = __webpack_public_path__ + "images/exclamacao.png?693adaf28f59be48c9f985e4c93756bb";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/exclamacao.png
// module id = 1000
// module chunks = 0